import React, { useState, PropsWithChildren } from 'react';
import styled from '@emotion/styled';

import { darkGrey } from '~/src/styles/styled-variables';

import { CloseButton as CloseButtonBase, Modal, ModalContentWrapper } from './elements';
import { SignInForm, ForgotPasswordForm } from './modalForms';

interface SignInProps {
  email?: string;
  hideCreateAccount?: boolean;
  loginHeading?: string;
  open: boolean;
  setOpen?(open: boolean): void;
}

type SigninModalContent = 'signin' | 'forgot';

const CloseButton = styled(CloseButtonBase)`
  top: 15px;
  right: 15px;
  &::before,
  &::after {
    background-color: ${darkGrey};
  }
`;

const SignInBody: React.FC<PropsWithChildren<SignInProps>> = ({
  email,
  open,
  setOpen = () => undefined,
  ...props
}) => {
  const [content, setContent] = useState<SigninModalContent>('signin');
  const [emailAddress, setEmail] = useState(email || '');

  const modalContent =
    content === 'signin' ? (
      <SignInForm
        onClickForgotPassword={() => setContent('forgot')}
        setEmail={setEmail}
        closeModal={() => setOpen(false)}
        email={emailAddress}
        {...props}
      />
    ) : (
      <ForgotPasswordForm emailAddress={emailAddress} />
    );

  return (
    <Modal open={open}>
      <CloseButton
        data-testid="close-button"
        onClick={() => {
          setOpen(false);
          setContent('signin');
        }}
      />
      <ModalContentWrapper>{modalContent}</ModalContentWrapper>
    </Modal>
  );
};

export const SignInModal: React.FC<PropsWithChildren<SignInProps>> = ({ ...props }) => {
  const { open } = props;
  if (!open) {
    return null;
  }
  return <SignInBody {...props} />;
};
